import React from "react";
import PropTypes from "prop-types";
import Dialog from "./DialogPublish";
import { Image, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  content: {
    paddingTop: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  }
});

export default function PreviewDialog({ imageSrc, children, loading, ...props }) {
  const styles = useStyles();

  return (
    <Dialog maxWidth={"500px"} {...props}>
      <div>
        <Image src={imageSrc} />
      </div>

      <div className={styles.content}>{children}</div>
    </Dialog>
  );
}

PreviewDialog.propTypes = {
  imageSrc: PropTypes.string,
  children: PropTypes.node,
  loading: PropTypes.bool
};
